// confirmToast.js
import { toast } from "react-toastify";
import React, { useEffect, useRef } from "react";
import './ConfiirmToast.css'

let toastId = null;

export function confirmToast(message = "Are you sure?", options={}) {

  const {closeOnOutsideClick = true, } = options;
  toast.dismiss();

  return new Promise((resolve) => {
    const ToastContent = () => {
      const toastRef = useRef();

      useEffect(() => {
        if (!closeOnOutsideClick) return;
        const handleClickOutside = (event) => {
          if (toastRef.current && !toastRef.current.contains(event.target)) {
            resolve(false);
            toast.dismiss(toastId);
          }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
          document.removeEventListener("mousedown", handleClickOutside);
        };
      }, []);

      return (
        <div ref={toastRef} className="confimToast-main">
          <div className="confirmToast-message">{message}</div>
          <div  className=" confirToast-btn-main">
            <button
              onClick={() => {
                resolve(true);
                toast.dismiss(toastId);
              }}
              style={{
                padding: "4px 10px",
                cursor: "pointer",
                border: "1px solid #ccc",
                color: "white",
                backgroundColor: "#28a745",
                borderRadius: "4px",
              }}
            >
              Yes
            </button>
            <button
              onClick={() => {
                resolve(false);
                toast.dismiss(toastId);
              }}
              style={{
                padding: "4px 10px",
                cursor: "pointer",
                border: "1px solid #ccc",
                color: "white",
                backgroundColor: "#dc3545",
                borderRadius: "4px",
              }}
            >
              No
            </button>
          </div>
        </div>
      );
    };

    toastId = toast(<ToastContent />, {
      autoClose: false,
      closeOnClick: false,
      draggable: false,
      position: "top-center",
    });
  });
}

export function getCurrentToastId() {
  return toastId;
}
